// extracted by mini-css-extract-plugin
export var label = "_jn-0";
export var treatmentCard = "_jn-1";